var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "900", scrollable: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.testResponse
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("campaign_factory.test.result_title")) +
                      "\n      "
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-simple-table",
                    { attrs: { light: true, dense: true } },
                    [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c("td", { staticClass: "result-modal__key" }, [
                              _vm._v("State"),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-bold",
                                  class: _vm.stateClass,
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$tc(
                                          "campaign_factory.test.state." +
                                            _vm.testResponse.state
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.testResponse.errorCode > 0
                            ? _c("tr", [
                                _c("td", { staticClass: "result-modal__key" }, [
                                  _vm._v("ErrorCode"),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.testResponse.errorCode)),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.testResponse.errorMessage
                            ? _c("tr", [
                                _c("td", { staticClass: "result-modal__key" }, [
                                  _vm._v("ErrorMessage"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "result-modal__value" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.testResponse.errorMessage) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasCacheable
                            ? _c("tr", [
                                _c("td", { staticClass: "result-modal__key" }, [
                                  _vm._v("cacheable"),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.testResponse.cacheable)),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.testResponse.remotePath
                            ? _c("tr", [
                                _c("td", { staticClass: "result-modal__key" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "campaign_factory.test.batch.remote_path"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "result-modal__value" },
                                  [_vm._v(_vm._s(_vm.testResponse.remotePath))]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.testResponse.exportedCount !== undefined
                            ? _c("tr", [
                                _c("td", { staticClass: "result-modal__key" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "campaign_factory.test.batch.exported_count"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.testResponse.exportedCount)
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.debug, function (value, name) {
                            return _c("tr", { key: name }, [
                              _c("td", { staticClass: "result-modal__key" }, [
                                _vm._v(_vm._s(name)),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "result-modal__value" }, [
                                _vm._v(_vm._s(value)),
                              ]),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("campaign_factory.test.close")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }